import { render, staticRenderFns } from "./TableEmpresa.vue?vue&type=template&id=f9fbf3c6&scoped=true&"
import script from "./TableEmpresa.vue?vue&type=script&lang=js&"
export * from "./TableEmpresa.vue?vue&type=script&lang=js&"
import style0 from "./TableEmpresa.vue?vue&type=style&index=0&id=f9fbf3c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9fbf3c6",
  null
  
)

export default component.exports